function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.294 14.1a10 10 0 005.882 0l27.905-8.586a2.5 2.5 0 00-1.47-4.779L36.176 8.87a10 10 0 01-5.882 0L3.86.735a2.5 2.5 0 00-1.47 4.78L30.293 14.1z",
  fill: "currentColor"
});

function SvgWideArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 15,
    viewBox: "0 0 66 15",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCA2NiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIG9wYWNpdHk9IjAuOCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0iTTMwLjI5NDQgMTQuMTAwMkMzMi4yMTA2IDE0LjY4OTkgMzQuMjU5OCAxNC42ODk5IDM2LjE3NjEgMTQuMTAwM0w2NC4wODEgNS41MTQxMkM2NS40MDA2IDUuMTA4MDcgNjYuMTQxMyAzLjcwOTEyIDY1LjczNTIgMi4zODk0NkM2NS4zMjkyIDEuMDY5OCA2My45MzAyIDAuMzI5MTc5IDYyLjYxMDYgMC43MzUyMjZMMzYuMTc2MSA4Ljg2ODkxQzM0LjI1OTggOS40NTg1MyAzMi4yMTA2IDkuNDU4NTMgMzAuMjk0NCA4Ljg2ODkxTDMuODU5ODggMC43MzUyMjJDMi41NDAyMiAwLjMyOTE3NCAxLjE0MTI2IDEuMDY5OCAwLjczNTIxNiAyLjM4OTQ1QzAuMzI5MTY4IDMuNzA5MTEgMS4wNjk3OSA1LjEwODA3IDIuMzg5NDQgNS41MTQxMkwzMC4yOTQ0IDE0LjEwMDJaIgogICAgICAgIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+";
export { SvgWideArrowDown as ReactComponent };